[
  {
    "code": "DE-RP-AW",
    "name": "Ahrweiler"
  },
  {
    "code": "DE-BY-AIC",
    "name": "Aichach-Friedberg"
  },
  {
    "code": "DE-BW-UL2",
    "name": "Alb-Donau-Kreis"
  },
  {
    "code": "DE-TH-ABG",
    "name": "Altenburger Land"
  },
  {
    "code": "DE-RP-AK",
    "name": "Altenkirchen (Westerwald)"
  },
  {
    "code": "DE-ST-SAW",
    "name": "Altmarkkreis Salzwedel"
  },
  {
    "code": "DE-BY-AO",
    "name": "Altötting"
  },
  {
    "code": "DE-RP-AZ",
    "name": "Alzey-Worms"
  },
  {
    "code": "DE-BY-AM",
    "name": "Amberg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-AS",
    "name": "Amberg-Sulzbach"
  },
  {
    "code": "DE-NI-WST",
    "name": "Ammerland"
  },
  {
    "code": "DE-ST-ABI",
    "name": "Anhalt-Bitterfeld"
  },
  {
    "code": "DE-BY-AN2",
    "name": "Ansbach"
  },
  {
    "code": "DE-BY-AN1",
    "name": "Ansbach (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-AB2",
    "name": "Aschaffenburg"
  },
  {
    "code": "DE-BY-AB1",
    "name": "Aschaffenburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-A2",
    "name": "Augsburg"
  },
  {
    "code": "DE-BY-A1",
    "name": "Augsburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-AUR",
    "name": "Aurich"
  },
  {
    "code": "DE-RP-DUW",
    "name": "Bad Dürkheim"
  },
  {
    "code": "DE-BY-KG",
    "name": "Bad Kissingen"
  },
  {
    "code": "DE-RP-KH",
    "name": "Bad Kreuznach"
  },
  {
    "code": "DE-BY-TOL",
    "name": "Bad Tölz-Wolfratshausen"
  },
  {
    "code": "DE-BW-BAD",
    "name": "Baden-Baden (Stadtkreis)"
  },
  {
    "code": "DE-BY-BA2",
    "name": "Bamberg"
  },
  {
    "code": "DE-BY-BA1",
    "name": "Bamberg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BB-BAR",
    "name": "Barnim"
  },
  {
    "code": "DE-SN-BZ",
    "name": "Bautzen"
  },
  {
    "code": "DE-BY-BT2",
    "name": "Bayreuth"
  },
  {
    "code": "DE-BY-BT1",
    "name": "Bayreuth (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-BGL",
    "name": "Berchtesgadener Land"
  },
  {
    "code": "DE-HE-HP",
    "name": "Bergstraße"
  },
  {
    "code": "DE-BE-B1",
    "name": "Berlin (Kreisfreie Stadt)"
  },
  {
    "code": "DE-RP-WIL",
    "name": "Bernkastel-Wittlich"
  },
  {
    "code": "DE-BW-BC",
    "name": "Biberach"
  },
  {
    "code": "DE-NW-BI",
    "name": "Bielefeld (Kreisfreie Stadt)"
  },
  {
    "code": "DE-RP-BIR",
    "name": "Birkenfeld"
  },
  {
    "code": "DE-NW-BO",
    "name": "Bochum (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-FN",
    "name": "Bodenseekreis"
  },
  {
    "code": "DE-NW-BN",
    "name": "Bonn (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NW-BOR",
    "name": "Borken"
  },
  {
    "code": "DE-NW-BOT",
    "name": "Bottrop (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BB-BRB",
    "name": "Brandenburg an der Havel (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-BS",
    "name": "Braunschweig (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-FR2",
    "name": "Breisgau-Hochschwarzwald"
  },
  {
    "code": "DE-HB-HB",
    "name": "Bremen (Freie Hansestadt)"
  },
  {
    "code": "DE-HB-HBH",
    "name": "Bremerhaven (Kreisfreie Stadt)"
  },
  {
    "code": "DE-ST-BLK",
    "name": "Burgenlandkreis"
  },
  {
    "code": "DE-BW-BB",
    "name": "Böblingen"
  },
  {
    "code": "DE-ST-BK",
    "name": "Börde"
  },
  {
    "code": "DE-BW-CW",
    "name": "Calw"
  },
  {
    "code": "DE-NI-CE",
    "name": "Celle"
  },
  {
    "code": "DE-BY-CHA",
    "name": "Cham"
  },
  {
    "code": "DE-SN-C1",
    "name": "Chemnitz (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-CLP",
    "name": "Cloppenburg"
  },
  {
    "code": "DE-BY-CO2",
    "name": "Coburg"
  },
  {
    "code": "DE-BY-CO1",
    "name": "Coburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-RP-COC",
    "name": "Cochem-Zell"
  },
  {
    "code": "DE-NW-COE",
    "name": "Coesfeld"
  },
  {
    "code": "DE-BB-CB",
    "name": "Cottbus (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-CUX",
    "name": "Cuxhaven"
  },
  {
    "code": "DE-BY-DAH",
    "name": "Dachau"
  },
  {
    "code": "DE-BB-LDS",
    "name": "Dahme-Spreewald"
  },
  {
    "code": "DE-HE-DA1",
    "name": "Darmstadt (Kreisfreie Stadt)"
  },
  {
    "code": "DE-HE-DA2",
    "name": "Darmstadt-Dieburg"
  },
  {
    "code": "DE-BY-DEG",
    "name": "Deggendorf"
  },
  {
    "code": "DE-NI-DEL",
    "name": "Delmenhorst (Kreisfreie Stadt)"
  },
  {
    "code": "DE-ST-DE",
    "name": "Dessau-Roßlau (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-DH",
    "name": "Diepholz"
  },
  {
    "code": "DE-BY-DLG",
    "name": "Dillingen an der Donau"
  },
  {
    "code": "DE-BY-DGF",
    "name": "Dingolfing-Landau"
  },
  {
    "code": "DE-SH-HEI",
    "name": "Dithmarschen"
  },
  {
    "code": "DE-BY-DON",
    "name": "Donau-Ries"
  },
  {
    "code": "DE-RP-KIB",
    "name": "Donnersbergkreis"
  },
  {
    "code": "DE-NW-DO",
    "name": "Dortmund (Kreisfreie Stadt)"
  },
  {
    "code": "DE-SN-DD",
    "name": "Dresden (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NW-DU",
    "name": "Duisburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NW-DN",
    "name": "Düren"
  },
  {
    "code": "DE-NW-D1",
    "name": "Düsseldorf (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-EBE",
    "name": "Ebersberg"
  },
  {
    "code": "DE-TH-EIC",
    "name": "Eichsfeld"
  },
  {
    "code": "DE-BY-EI",
    "name": "Eichstätt"
  },
  {
    "code": "DE-RP-BIT",
    "name": "Eifelkreis Bitburg-Prüm"
  },
  {
    "code": "DE-BB-EE",
    "name": "Elbe-Elster"
  },
  {
    "code": "DE-NI-EMD",
    "name": "Emden (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-EM",
    "name": "Emmendingen"
  },
  {
    "code": "DE-NI-EL",
    "name": "Emsland"
  },
  {
    "code": "DE-NW-EN",
    "name": "Ennepe-Ruhr-Kreis"
  },
  {
    "code": "DE-BW-PF2",
    "name": "Enzkreis"
  },
  {
    "code": "DE-BY-ED",
    "name": "Erding"
  },
  {
    "code": "DE-TH-EF",
    "name": "Erfurt (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-ER",
    "name": "Erlangen (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-ERH",
    "name": "Erlangen-Höchstadt"
  },
  {
    "code": "DE-SN-ERZ",
    "name": "Erzgebirgskreis"
  },
  {
    "code": "DE-NW-E1",
    "name": "Essen (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-ES",
    "name": "Esslingen"
  },
  {
    "code": "DE-NW-EU",
    "name": "Euskirchen"
  },
  {
    "code": "DE-SH-FL",
    "name": "Flensburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-FO",
    "name": "Forchheim"
  },
  {
    "code": "DE-RP-FT",
    "name": "Frankenthal (Pfalz) (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BB-FF",
    "name": "Frankfurt (Oder) (Kreisfreie Stadt)"
  },
  {
    "code": "DE-HE-F1",
    "name": "Frankfurt am Main (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-FR1",
    "name": "Freiburg im Breisgau (Stadtkreis)"
  },
  {
    "code": "DE-BY-FS",
    "name": "Freising"
  },
  {
    "code": "DE-BW-FDS",
    "name": "Freudenstadt"
  },
  {
    "code": "DE-BY-FRG",
    "name": "Freyung-Grafenau"
  },
  {
    "code": "DE-NI-FRI",
    "name": "Friesland"
  },
  {
    "code": "DE-HE-FD",
    "name": "Fulda"
  },
  {
    "code": "DE-BY-FFB",
    "name": "Fürstenfeldbruck"
  },
  {
    "code": "DE-BY-FU2",
    "name": "Fürth"
  },
  {
    "code": "DE-BY-FU1",
    "name": "Fürth (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-GAP",
    "name": "Garmisch-Partenkirchen"
  },
  {
    "code": "DE-NW-GE",
    "name": "Gelsenkirchen (Kreisfreie Stadt)"
  },
  {
    "code": "DE-TH-G1",
    "name": "Gera (Kreisfreie Stadt)"
  },
  {
    "code": "DE-RP-GER",
    "name": "Germersheim"
  },
  {
    "code": "DE-HE-GI",
    "name": "Gießen"
  },
  {
    "code": "DE-NI-GF",
    "name": "Gifhorn"
  },
  {
    "code": "DE-NI-GS",
    "name": "Goslar"
  },
  {
    "code": "DE-TH-GTH",
    "name": "Gotha"
  },
  {
    "code": "DE-NI-NOH",
    "name": "Grafschaft Bentheim"
  },
  {
    "code": "DE-TH-GRZ",
    "name": "Greiz"
  },
  {
    "code": "DE-HE-GG",
    "name": "Groß-Gerau"
  },
  {
    "code": "DE-BW-GP",
    "name": "Göppingen"
  },
  {
    "code": "DE-SN-GR",
    "name": "Görlitz"
  },
  {
    "code": "DE-NI-GO",
    "name": "Göttingen"
  },
  {
    "code": "DE-BY-GZ",
    "name": "Günzburg"
  },
  {
    "code": "DE-NW-GT",
    "name": "Gütersloh"
  },
  {
    "code": "DE-NW-HA",
    "name": "Hagen (Kreisfreie Stadt)"
  },
  {
    "code": "DE-ST-HAL",
    "name": "Halle (Saale) (Kreisfreie Stadt)"
  },
  {
    "code": "DE-HH-HH",
    "name": "Hamburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-HM",
    "name": "Hameln-Pyrmont"
  },
  {
    "code": "DE-NW-HAM",
    "name": "Hamm (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-WL",
    "name": "Harburg"
  },
  {
    "code": "DE-ST-HZ",
    "name": "Harz"
  },
  {
    "code": "DE-BB-HVL",
    "name": "Havelland"
  },
  {
    "code": "DE-BY-HAS",
    "name": "Haßberge"
  },
  {
    "code": "DE-NI-HK",
    "name": "Heidekreis"
  },
  {
    "code": "DE-BW-HD1",
    "name": "Heidelberg (Stadtkreis)"
  },
  {
    "code": "DE-BW-HDH",
    "name": "Heidenheim"
  },
  {
    "code": "DE-BW-HN2",
    "name": "Heilbronn"
  },
  {
    "code": "DE-BW-HN1",
    "name": "Heilbronn (Stadtkreis)"
  },
  {
    "code": "DE-NW-HS",
    "name": "Heinsberg"
  },
  {
    "code": "DE-SH-HEL",
    "name": "Helgoland"
  },
  {
    "code": "DE-NI-HE",
    "name": "Helmstedt"
  },
  {
    "code": "DE-NW-HF",
    "name": "Herford"
  },
  {
    "code": "DE-NW-HER",
    "name": "Herne (Kreisfreie Stadt)"
  },
  {
    "code": "DE-HE-HEF",
    "name": "Hersfeld-Rotenburg"
  },
  {
    "code": "DE-SH-RZ",
    "name": "Herzogtum Lauenburg"
  },
  {
    "code": "DE-TH-HBN",
    "name": "Hildburghausen"
  },
  {
    "code": "DE-NI-HI",
    "name": "Hildesheim"
  },
  {
    "code": "DE-NW-HSK",
    "name": "Hochsauerlandkreis"
  },
  {
    "code": "DE-HE-HG",
    "name": "Hochtaunuskreis"
  },
  {
    "code": "DE-BY-HO2",
    "name": "Hof"
  },
  {
    "code": "DE-BY-HO1",
    "name": "Hof (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-KUN",
    "name": "Hohenlohekreis"
  },
  {
    "code": "DE-NI-HOL",
    "name": "Holzminden"
  },
  {
    "code": "DE-NW-HX",
    "name": "Höxter"
  },
  {
    "code": "DE-TH-IK",
    "name": "Ilm-Kreis"
  },
  {
    "code": "DE-BY-IN",
    "name": "Ingolstadt (Kreisfreie Stadt)"
  },
  {
    "code": "DE-TH-J1",
    "name": "Jena"
  },
  {
    "code": "DE-ST-JL",
    "name": "Jerichower Land"
  },
  {
    "code": "DE-RP-KL2",
    "name": "Kaiserslautern"
  },
  {
    "code": "DE-RP-KL1",
    "name": "Kaiserslautern (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-KA2",
    "name": "Karlsruhe"
  },
  {
    "code": "DE-BW-KA1",
    "name": "Karlsruhe (Stadtkreis)"
  },
  {
    "code": "DE-HE-KS2",
    "name": "Kassel"
  },
  {
    "code": "DE-HE-KS1",
    "name": "Kassel (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-KF",
    "name": "Kaufbeuren (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-KEH",
    "name": "Kelheim"
  },
  {
    "code": "DE-BY-KE",
    "name": "Kempten (Allgäu)"
  },
  {
    "code": "DE-SH-KI",
    "name": "Kiel (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-KT",
    "name": "Kitzingen"
  },
  {
    "code": "DE-NW-KLE",
    "name": "Kleve"
  },
  {
    "code": "DE-RP-KO",
    "name": "Koblenz (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-KN",
    "name": "Konstanz"
  },
  {
    "code": "DE-NW-KR",
    "name": "Krefeld (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-KC",
    "name": "Kronach"
  },
  {
    "code": "DE-BY-KU",
    "name": "Kulmbach"
  },
  {
    "code": "DE-RP-KUS",
    "name": "Kusel"
  },
  {
    "code": "DE-TH-KYF",
    "name": "Kyffhäuserkreis"
  },
  {
    "code": "DE-NW-K1",
    "name": "Köln (Kreisfreie Stadt)"
  },
  {
    "code": "DE-HE-LDK",
    "name": "Lahn-Dill-Kreis"
  },
  {
    "code": "DE-RP-LD",
    "name": "Landau in der Pfalz (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-LL",
    "name": "Landsberg am Lech"
  },
  {
    "code": "DE-BY-LA2",
    "name": "Landshut"
  },
  {
    "code": "DE-BY-LA1",
    "name": "Landshut (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-LER",
    "name": "Leer"
  },
  {
    "code": "DE-SN-L2",
    "name": "Leipzig"
  },
  {
    "code": "DE-SN-L1",
    "name": "Leipzig (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NW-LEV",
    "name": "Leverkusen (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-LIF",
    "name": "Lichtenfels"
  },
  {
    "code": "DE-HE-LM",
    "name": "Limburg-Weilburg"
  },
  {
    "code": "DE-BY-LI",
    "name": "Lindau (Bodensee)"
  },
  {
    "code": "DE-NW-LIP",
    "name": "Lippe"
  },
  {
    "code": "DE-BW-LB",
    "name": "Ludwigsburg"
  },
  {
    "code": "DE-RP-LU",
    "name": "Ludwigshafen am Rhein (Kreisfreie Stadt)"
  },
  {
    "code": "DE-MV-LUP",
    "name": "Ludwigslust-Parchim"
  },
  {
    "code": "DE-BW-LO",
    "name": "Lörrach"
  },
  {
    "code": "DE-SH-HL",
    "name": "Lübeck (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-DAN",
    "name": "Lüchow-Dannenberg"
  },
  {
    "code": "DE-NI-LG",
    "name": "Lüneburg"
  },
  {
    "code": "DE-ST-MD",
    "name": "Magdeburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-HE-MKK",
    "name": "Main-Kinzig-Kreis"
  },
  {
    "code": "DE-BY-MSP",
    "name": "Main-Spessart"
  },
  {
    "code": "DE-BW-TBB",
    "name": "Main-Tauber-Kreis"
  },
  {
    "code": "DE-HE-MTK",
    "name": "Main-Taunus-Kreis"
  },
  {
    "code": "DE-RP-MZ1",
    "name": "Mainz (Kreisfreie Stadt)"
  },
  {
    "code": "DE-RP-MZ2",
    "name": "Mainz-Bingen"
  },
  {
    "code": "DE-BW-MA",
    "name": "Mannheim (Stadtkreis)"
  },
  {
    "code": "DE-ST-MSH",
    "name": "Mansfeld-Südharz"
  },
  {
    "code": "DE-HE-MR",
    "name": "Marburg-Biedenkopf"
  },
  {
    "code": "DE-RP-MYK",
    "name": "Mayen-Koblenz"
  },
  {
    "code": "DE-MV-MSE",
    "name": "Mecklenburgische Seenplatte"
  },
  {
    "code": "DE-SN-MEI",
    "name": "Meißen"
  },
  {
    "code": "DE-BY-MM",
    "name": "Memmingen (Kreisfreie Stadt)"
  },
  {
    "code": "DE-SL-MZG",
    "name": "Merzig-Wadern"
  },
  {
    "code": "DE-NW-ME",
    "name": "Mettmann"
  },
  {
    "code": "DE-BY-MB",
    "name": "Miesbach"
  },
  {
    "code": "DE-BY-MIL",
    "name": "Miltenberg"
  },
  {
    "code": "DE-NW-MI",
    "name": "Minden-Lübbecke"
  },
  {
    "code": "DE-SN-FG",
    "name": "Mittelsachsen"
  },
  {
    "code": "DE-BB-MOL",
    "name": "Märkisch-Oderland"
  },
  {
    "code": "DE-NW-MK",
    "name": "Märkischer Kreis"
  },
  {
    "code": "DE-NW-MG",
    "name": "Mönchengladbach (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-MU",
    "name": "Mühldorf am Inn"
  },
  {
    "code": "DE-NW-MH",
    "name": "Mülheim an der Ruhr (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-M2",
    "name": "München"
  },
  {
    "code": "DE-BY-M1",
    "name": "München (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NW-MS",
    "name": "Münster (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-MOS",
    "name": "Neckar-Odenwald-Kreis"
  },
  {
    "code": "DE-BY-NU",
    "name": "Neu-Ulm"
  },
  {
    "code": "DE-BY-ND",
    "name": "Neuburg-Schrobenhausen"
  },
  {
    "code": "DE-BY-NM",
    "name": "Neumarkt in der Oberpfalz"
  },
  {
    "code": "DE-SH-NMS",
    "name": "Neumünster (Kreisfreie Stadt)"
  },
  {
    "code": "DE-SL-NK",
    "name": "Neunkirchen"
  },
  {
    "code": "DE-BY-NEA",
    "name": "Neustadt an der Aisch-Bad Windsheim (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-NEW",
    "name": "Neustadt an der Waldnaab"
  },
  {
    "code": "DE-RP-NW",
    "name": "Neustadt an der Weinstraße (Kreisfreie Stadt)"
  },
  {
    "code": "DE-HH-NW",
    "name": "Neuwerk"
  },
  {
    "code": "DE-RP-NR",
    "name": "Neuwied"
  },
  {
    "code": "DE-NI-NI",
    "name": "Nienburg (Weser)"
  },
  {
    "code": "DE-SH-NF",
    "name": "Nordfriesland"
  },
  {
    "code": "DE-TH-NDH",
    "name": "Nordhausen"
  },
  {
    "code": "DE-SN-TDO",
    "name": "Nordsachsen"
  },
  {
    "code": "DE-MV-NWM",
    "name": "Nordwestmecklenburg"
  },
  {
    "code": "DE-NI-NOM",
    "name": "Northeim"
  },
  {
    "code": "DE-BY-N1",
    "name": "Nürnberg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-LAU",
    "name": "Nürnberger Land"
  },
  {
    "code": "DE-BY-OA",
    "name": "Oberallgäu"
  },
  {
    "code": "DE-NW-GM",
    "name": "Oberbergischer Kreis"
  },
  {
    "code": "DE-NW-OB",
    "name": "Oberhausen (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BB-OHV",
    "name": "Oberhavel"
  },
  {
    "code": "DE-BB-OSL",
    "name": "Oberspreewald-Lausitz"
  },
  {
    "code": "DE-HE-OK",
    "name": "Odenwaldkreis"
  },
  {
    "code": "DE-BB-LOS",
    "name": "Oder-Spree"
  },
  {
    "code": "DE-HE-OF2",
    "name": "Offenbach"
  },
  {
    "code": "DE-HE-OF1",
    "name": "Offenbach am Main"
  },
  {
    "code": "DE-NI-OL2",
    "name": "Oldenburg"
  },
  {
    "code": "DE-NI-OL1",
    "name": "Oldenburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NW-OE",
    "name": "Olpe"
  },
  {
    "code": "DE-BW-OG",
    "name": "Ortenaukreis"
  },
  {
    "code": "DE-NI-OS2",
    "name": "Osnabrück"
  },
  {
    "code": "DE-NI-OS1",
    "name": "Osnabrück (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-AA",
    "name": "Ostalbkreis"
  },
  {
    "code": "DE-BY-OAL",
    "name": "Ostallgäu"
  },
  {
    "code": "DE-NI-OHZ",
    "name": "Osterholz"
  },
  {
    "code": "DE-SH-OH",
    "name": "Ostholstein"
  },
  {
    "code": "DE-BB-OPR",
    "name": "Ostprignitz-Ruppin"
  },
  {
    "code": "DE-NW-PB",
    "name": "Paderborn"
  },
  {
    "code": "DE-BY-PA2",
    "name": "Passau"
  },
  {
    "code": "DE-BY-PA1",
    "name": "Passau (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-PE",
    "name": "Peine"
  },
  {
    "code": "DE-BY-PAF",
    "name": "Pfaffenhofen an der Ilm"
  },
  {
    "code": "DE-BW-PF1",
    "name": "Pforzheim (Stadtkreis)"
  },
  {
    "code": "DE-SH-PI",
    "name": "Pinneberg"
  },
  {
    "code": "DE-RP-PS1",
    "name": "Pirmasens (Kreisfreie Stadt)"
  },
  {
    "code": "DE-SH-PLO",
    "name": "Plön"
  },
  {
    "code": "DE-BB-P1",
    "name": "Potsdam (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BB-PM",
    "name": "Potsdam-Mittelmark"
  },
  {
    "code": "DE-BB-PR",
    "name": "Prignitz"
  },
  {
    "code": "DE-BW-RA",
    "name": "Rastatt"
  },
  {
    "code": "DE-BW-RV",
    "name": "Ravensburg"
  },
  {
    "code": "DE-NW-RE",
    "name": "Recklinghausen"
  },
  {
    "code": "DE-BY-REG",
    "name": "Regen"
  },
  {
    "code": "DE-BY-R2",
    "name": "Regensburg"
  },
  {
    "code": "DE-BY-R1",
    "name": "Regensburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-H1",
    "name": "Region Hannover"
  },
  {
    "code": "DE-SL-SB",
    "name": "Regionalverband Saarbrücken"
  },
  {
    "code": "DE-BW-WN",
    "name": "Rems-Murr-Kreis"
  },
  {
    "code": "DE-NW-RS",
    "name": "Remscheid (Kreisfreie Stadt)"
  },
  {
    "code": "DE-SH-RD",
    "name": "Rendsburg-Eckernförde"
  },
  {
    "code": "DE-BW-RT",
    "name": "Reutlingen"
  },
  {
    "code": "DE-NW-BM",
    "name": "Rhein-Erft-Kreis"
  },
  {
    "code": "DE-RP-SIM",
    "name": "Rhein-Hunsrück-Kreis"
  },
  {
    "code": "DE-NW-NE",
    "name": "Rhein-Kreis Neuss"
  },
  {
    "code": "DE-RP-EMS",
    "name": "Rhein-Lahn-Kreis"
  },
  {
    "code": "DE-BW-HD2",
    "name": "Rhein-Neckar-Kreis"
  },
  {
    "code": "DE-RP-RP",
    "name": "Rhein-Pfalz-Kreis"
  },
  {
    "code": "DE-NW-SU",
    "name": "Rhein-Sieg-Kreis"
  },
  {
    "code": "DE-HE-RUD",
    "name": "Rheingau-Taunus-Kreis"
  },
  {
    "code": "DE-NW-GL",
    "name": "Rheinisch-Bergischer Kreis"
  },
  {
    "code": "DE-BY-NES",
    "name": "Rhön-Grabfeld"
  },
  {
    "code": "DE-BY-RO2",
    "name": "Rosenheim"
  },
  {
    "code": "DE-BY-RO1",
    "name": "Rosenheim (Kreisfreie Stadt)"
  },
  {
    "code": "DE-MV-LRO",
    "name": "Rostock"
  },
  {
    "code": "DE-MV-HRO",
    "name": "Rostock (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-ROW",
    "name": "Rotenburg (Wümme)"
  },
  {
    "code": "DE-BY-RH",
    "name": "Roth"
  },
  {
    "code": "DE-BY-PAN",
    "name": "Rottal-Inn"
  },
  {
    "code": "DE-BW-RW",
    "name": "Rottweil"
  },
  {
    "code": "DE-TH-SHK",
    "name": "Saale-Holzland-Kreis"
  },
  {
    "code": "DE-TH-SOK",
    "name": "Saale-Orla-Kreis"
  },
  {
    "code": "DE-ST-SK",
    "name": "Saalekreis"
  },
  {
    "code": "DE-TH-SLF",
    "name": "Saalfeld-Rudolstadt"
  },
  {
    "code": "DE-SL-SLS",
    "name": "Saarlouis"
  },
  {
    "code": "DE-SL-HOM",
    "name": "Saarpfalz-Kreis"
  },
  {
    "code": "DE-NI-SZ",
    "name": "Salzgitter (Kreisfreie Stadt)"
  },
  {
    "code": "DE-ST-SLK",
    "name": "Salzlandkreis"
  },
  {
    "code": "DE-NI-SHG",
    "name": "Schaumburg"
  },
  {
    "code": "DE-SH-SL",
    "name": "Schleswig-Flensburg"
  },
  {
    "code": "DE-TH-SM",
    "name": "Schmalkalden-Meiningen"
  },
  {
    "code": "DE-BY-SC",
    "name": "Schwabach (Kreisfreie Stadt)"
  },
  {
    "code": "DE-HE-HR",
    "name": "Schwalm-Eder-Kreis"
  },
  {
    "code": "DE-BY-SAD",
    "name": "Schwandorf"
  },
  {
    "code": "DE-BW-VS",
    "name": "Schwarzwald-Baar-Kreis"
  },
  {
    "code": "DE-BY-SW2",
    "name": "Schweinfurt"
  },
  {
    "code": "DE-BY-SW1",
    "name": "Schweinfurt (Kreisfreie Stadt)"
  },
  {
    "code": "DE-MV-SN",
    "name": "Schwerin (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-SHA",
    "name": "Schwäbisch Hall"
  },
  {
    "code": "DE-SH-SE",
    "name": "Segeberg"
  },
  {
    "code": "DE-NW-SI",
    "name": "Siegen-Wittgenstein"
  },
  {
    "code": "DE-BW-SIG",
    "name": "Sigmaringen"
  },
  {
    "code": "DE-NW-SO",
    "name": "Soest"
  },
  {
    "code": "DE-NW-SG",
    "name": "Solingen (Kreisfreie Stadt)"
  },
  {
    "code": "DE-TH-SON",
    "name": "Sonneberg"
  },
  {
    "code": "DE-RP-SP",
    "name": "Speyer (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BB-SPN",
    "name": "Spree-Neiße"
  },
  {
    "code": "DE-SL-WND",
    "name": "St. Wendel"
  },
  {
    "code": "DE-NI-STD",
    "name": "Stade"
  },
  {
    "code": "DE-BY-STA",
    "name": "Starnberg"
  },
  {
    "code": "DE-SH-IZ",
    "name": "Steinburg"
  },
  {
    "code": "DE-NW-ST",
    "name": "Steinfurt"
  },
  {
    "code": "DE-ST-SDL",
    "name": "Stendal"
  },
  {
    "code": "DE-SH-OD",
    "name": "Stormarn"
  },
  {
    "code": "DE-BY-SR1",
    "name": "Straubing (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-SR2",
    "name": "Straubing-Bogen"
  },
  {
    "code": "DE-BW-S1",
    "name": "Stuttgart (Stadtkreis)"
  },
  {
    "code": "DE-NW-AC",
    "name": "Städteregion Aachen"
  },
  {
    "code": "DE-TH-SHL",
    "name": "Suhl (Kreisfreie Stadt)"
  },
  {
    "code": "DE-SN-PIR",
    "name": "Sächsische Schweiz-Osterzgebirge"
  },
  {
    "code": "DE-TH-SOM",
    "name": "Sömmerda"
  },
  {
    "code": "DE-RP-SUW",
    "name": "Südliche Weinstraße"
  },
  {
    "code": "DE-RP-PS2",
    "name": "Südwestpfalz"
  },
  {
    "code": "DE-BB-TF",
    "name": "Teltow-Fläming"
  },
  {
    "code": "DE-BY-TIR",
    "name": "Tirschenreuth"
  },
  {
    "code": "DE-BY-TS",
    "name": "Traunstein"
  },
  {
    "code": "DE-RP-TR1",
    "name": "Trier (Kreisfreie Stadt)"
  },
  {
    "code": "DE-RP-TR2",
    "name": "Trier-Saarburg"
  },
  {
    "code": "DE-BW-TUT",
    "name": "Tuttlingen"
  },
  {
    "code": "DE-BW-TU",
    "name": "Tübingen"
  },
  {
    "code": "DE-BB-UM",
    "name": "Uckermark"
  },
  {
    "code": "DE-NI-UE",
    "name": "Uelzen"
  },
  {
    "code": "DE-BW-UL1",
    "name": "Ulm (Stadtkreis)"
  },
  {
    "code": "DE-NW-UN",
    "name": "Unna"
  },
  {
    "code": "DE-TH-UH",
    "name": "Unstrut-Hainich-Kreis"
  },
  {
    "code": "DE-BY-MN",
    "name": "Unterallgäu"
  },
  {
    "code": "DE-NI-VEC",
    "name": "Vechta"
  },
  {
    "code": "DE-NI-VER",
    "name": "Verden"
  },
  {
    "code": "DE-NW-VIE",
    "name": "Viersen"
  },
  {
    "code": "DE-HE-VB",
    "name": "Vogelsbergkreis"
  },
  {
    "code": "DE-SN-V1",
    "name": "Vogtlandkreis"
  },
  {
    "code": "DE-MV-VG",
    "name": "Vorpommern-Greifswald"
  },
  {
    "code": "DE-MV-VR",
    "name": "Vorpommern-Rügen"
  },
  {
    "code": "DE-RP-DAU",
    "name": "Vulkaneifel"
  },
  {
    "code": "DE-HE-KB",
    "name": "Waldeck-Frankenberg"
  },
  {
    "code": "DE-BW-WT",
    "name": "Waldshut"
  },
  {
    "code": "DE-NW-WAF",
    "name": "Warendorf"
  },
  {
    "code": "DE-TH-WAK",
    "name": "Wartburgkreis"
  },
  {
    "code": "DE-BY-WEN",
    "name": "Weiden in der Oberpfalz (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-WM",
    "name": "Weilheim-Schongau"
  },
  {
    "code": "DE-TH-WE",
    "name": "Weimar (Kreisfreie Stadt)"
  },
  {
    "code": "DE-TH-AP",
    "name": "Weimarer Land"
  },
  {
    "code": "DE-BY-WUG",
    "name": "Weißenburg-Gunzenhausen"
  },
  {
    "code": "DE-HE-ESW",
    "name": "Werra-Meißner-Kreis"
  },
  {
    "code": "DE-NW-WES",
    "name": "Wesel"
  },
  {
    "code": "DE-NI-BRA",
    "name": "Wesermarsch"
  },
  {
    "code": "DE-RP-WW",
    "name": "Westerwaldkreis"
  },
  {
    "code": "DE-HE-FB",
    "name": "Wetteraukreis"
  },
  {
    "code": "DE-HE-WI",
    "name": "Wiesbaden (Kreisfreie Stadt)"
  },
  {
    "code": "DE-NI-WHV",
    "name": "Wilhelmshaven (Kreisfreie Stadt)"
  },
  {
    "code": "DE-ST-WB",
    "name": "Wittenberg"
  },
  {
    "code": "DE-NI-WTM",
    "name": "Wittmund"
  },
  {
    "code": "DE-NI-WF",
    "name": "Wolfenbüttel"
  },
  {
    "code": "DE-NI-WOB",
    "name": "Wolfsburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-RP-WO",
    "name": "Worms (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-WUN",
    "name": "Wunsiedel im Fichtelgebirge"
  },
  {
    "code": "DE-NW-W1",
    "name": "Wuppertal (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BY-WU2",
    "name": "Würzburg"
  },
  {
    "code": "DE-BY-WU1",
    "name": "Würzburg (Kreisfreie Stadt)"
  },
  {
    "code": "DE-BW-BL",
    "name": "Zollernalbkreis"
  },
  {
    "code": "DE-RP-ZW",
    "name": "Zweibrücken (Kreisfreie Stadt)"
  },
  {
    "code": "DE-SN-Z1",
    "name": "Zwickau"
  }
]